import React from "react";
import Layout from "../components/share/layout";
import Bodyportal from "../components/bodyportal"
import '../styles/font-awesome-4.7.0/css/font-awesome.css'

const IndexPage = () => (
  <div className="super_container xd">
    <Layout description={"+Arte y Cultura"} title={"Bienvenidos a UPC Cultural"} subtitile={"+Arte y Cultura"} imgurl={"//cultural.upc.edu.pe/static/UpcCultural_Share-a1f8e23f2b58627c09d19c7bfc611366.jpg"}>
      <Bodyportal></Bodyportal>
    </Layout>
  </div>
)

export default IndexPage
